<script setup lang="ts">
interface Props {
  productCode?: string | null
}

const props = defineProps<Props>()

const { LocalConfigurationStore } = stores()
const metaTags = LocalConfigurationStore.value?.metaTags
const currentMetaTags = computed(() => {
  const code = props.productCode ?? null
  switch (code) {
    case null:
      return metaTags?.default
    default:
      return metaTags?.products?.[code]
  }
})
useSeoMeta(currentMetaTags.value ?? {})
</script>

<template>
  <div />
</template>
